module.exports = __webpack_public_path__ + "location.svg?01029240ee633923a78ac8fd1f2a972e";